module.exports = (__parcel__import__("9gwBc")).then(() => parcelRequire('jppWD'));